<template>
  <popup-container buttonLabel="close" :bodyFlex="true">
    <template slot="header">
      {{ title }}
    </template>

    <div class="message">
      <div>
      {{ $l.userBirthDayInputPlease }}
      </div>
    </div>

    <div class="birthday-input-year">
      <small>
        {{ $l.year }}
      </small>

      <input
        v-model="year"
        type="number"
        class="birthday-input"
        min="1900"
        >
    </div>

    <div class="birthday-input-month">
      <small>
        {{ $l.month }}
      </small>

      <input
        v-model="month"
        type="number"
        class="birthday-input"
        min="1"
        max="12"
        >
    </div>

    <div class="birthday-input-day">
      <small>
        {{ $l.day }}
      </small>

      <input
        v-model="date"
        type="number"
        class="birthday-input"
        min="1"
        max="31"
        >
    </div>
  </popup-container>
</template>

<script>
import PopupContainer from '@/components/Popup/Container'
import MixinLocale from '@/components/MixinLocale'
import MixinIsSettingsUser from '@/components/Settings/MixinIsSettingsUser'
import {
  getYear,
  getMonth,
  getDate
} from 'date-fns'
import _ from 'lodash'

export default {
  mixins: [
    MixinLocale,
    MixinIsSettingsUser,
  ],

  components: {
    PopupContainer
  },

  computed: {
    title: function () {
      if (this.isSettingsUser) {
        return this.$l.userBirthDayChange
      }
      return this.$l.userBirthDayInput
    },

    birthDay: function () {
      return this.$store.state.user.birthDay
    },

    year: {
      get: function () {
        return getYear(this.birthDay)
      },

      set: _.debounce(function (value) {
        this.$store.commit('user/setBirthDayYear', value)
        if (this.isSettingsUser) {
          this.$store.dispatch('user/saveBirthDay')
        }
      }, 1000)
    },

    month: {
      get: function () {
        return getMonth(this.birthDay) + 1
      },

      set: _.debounce(function (value) {
        this.$store.commit('user/setBirthDayMonth', value - 1)
        if (this.isSettingsUser) {
          this.$store.dispatch('user/saveBirthDay')
        }
      }, 1000)
    },

    date: {
      get: function () {
        return getDate(this.birthDay)
      },

      set: _.debounce(function (value) {
        this.$store.commit('user/setBirthDayDate', value)
        if (this.isSettingsUser) {
          this.$store.dispatch('user/saveBirthDay')
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.message {
  width: 100%;
  text-align: center;
  margin-bottom: -80px;
  align-items: end;
}

.input-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.birthday {
  padding: 10px;

  &-input {
    text-align: center;
    @include input-reset-design;
    border-bottom: 1px solid $silver;
    font-size: 1.2em;
    margin-top: 4px;
    padding-bottom: 4px;
    width: 100%;

    &:focus {
      border-bottom: 1px solid $peter-liver;
    }

    &-year {
      @extend .input-container;
      width: 25%;
      margin-right: 7px;
    }

    &-month {
      @extend .input-container;
      width: 15%;
      margin-left: 7px;
      margin-right: 7px;
    }

    &-day {
      @extend .input-container;
      width: 15%;
      margin-left: 7px;
    }
  }
}
</style>
